import norway from "../images/norway.svg";
import sweden from "../images/sweden.svg";
import denmark from "../images/denmark.svg";
import finland from "../images/finland.svg";
import iceland from "../images/iceland.svg";
import estonia from "../images/estonia.svg";
import latvia from "../images/latvia.svg";
import lithuania from "../images/lithuania.svg";
import slovenia from "../images/slovenia.svg";
import belgium from "../images/belgium.svg";

const participants = [
  {
    id: 1,
    flag: norway,
    countryName: "Norway",
  },
  {
    id: 2,
    flag: sweden,
    countryName: "Sweden",
  },
  {
    id: 3,
    flag: denmark,
    countryName: "Denmark",
  },
  {
    id: 4,
    flag: finland,
    countryName: "Finland",
  },
  {
    id: 5,
    flag: iceland,
    countryName: "Iceland",
  },
  {
    id: 6,
    flag: estonia,
    countryName: "Estonia",
  },
  {
    id: 7,
    flag: latvia,
    countryName: "Latvia",
  },
  {
    id: 8,
    flag: lithuania,
    countryName: "Lithuania",
  },
  {
    id: 9,
    flag: slovenia,
    countryName: "Slovenia",
  },
  {
    id: 10,
    flag: belgium,
    countryName: "Belgium",
  },
];

export default participants;
